// True when an element's text is clipped, i.e. wider than the box drawing it.
// Only meaningful on an element styled with `overflow: hidden` — otherwise
// scrollWidth and clientWidth agree no matter how long the text is.
export const isOverflowing = (el) => !!el && el.scrollWidth > el.clientWidth;

export default isOverflowing;
